export default __webpack_public_path__ + "static/media/step3-grey.67f9651e.svg";